// extracted by mini-css-extract-plugin
export var colorStripes = "j_L";
export var disclaimerStyle = "j_N";
export var genericBackgroundColor = "j_M";
export var skeletonRow = "j_H";
export var stickyClass = "j_K";
export var table = "j_h";
export var tableWrapper = "j_J";